module.exports = __webpack_public_path__ + "d23d29f01dfab016469e58c287e6a5ff.bg_inner.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/background/assets/bg_inner.jpg
// module id = Jgey
// module chunks = 0